"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const core_1 = require("@emotion/core");
const React = __importStar(require("react"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Checkbox = React.forwardRef((_a, ref) => {
    var { id, name, label, error, disabled, checked, value, ariaLabel, indeterminate, readOnly } = _a, rest = __rest(_a, ["id", "name", "label", "error", "disabled", "checked", "value", "ariaLabel", "indeterminate", "readOnly"]);
    const defaultRef = React.useRef(null);
    const resolvedRef = ref || defaultRef;
    const isChecked = checked !== undefined ? checked : value;
    React.useEffect(() => {
        if (resolvedRef.current) {
            resolvedRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate, ref]);
    return (core_1.jsx("label", { className: styles_scss_1.default.checkboxContainer, css: styles_1.default.container(isChecked, disabled), htmlFor: id, role: "presentation" },
        label && core_1.jsx("span", { className: styles_scss_1.default.label, css: styles_1.default.label(error) }, label),
        core_1.jsx("input", { ref: resolvedRef, id: id, name: name, type: "checkbox", "aria-label": ariaLabel, value: value, checked: isChecked, disabled: disabled, readOnly: readOnly, 
            // @ts-ignore
            onChange: rest.onChange, onBlur: rest.onBlur }),
        core_1.jsx("span", { className: styles_scss_1.default.checkboxCheckmark, css: styles_1.default.checkmark(checked, error, indeterminate) })));
});
Checkbox.defaultProps = {
    id: undefined,
    name: undefined,
    label: undefined,
    ariaLabel: undefined,
    value: false,
    checked: undefined,
    disabled: false,
    error: false,
    onChange: undefined,
    onBlur: undefined
};
exports.default = Checkbox;
